import React from "react";
import { View, StyleSheet } from "react-native";
import { ThemedText } from "@/components/ThemedText";
import { Button } from "@/components/ui/Button";
import { useTheme } from "@/hooks/useTheme";

export interface NavGuardModalProps {
  onGoBack: () => void;
  onDiscard: () => void;
}

export function NavGuardModal({ onGoBack, onDiscard }: NavGuardModalProps) {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.background, borderColor: colors.border }]}>
      <ThemedText type="title" style={styles.title}>
        You have unsaved changes on this page
      </ThemedText>

      <ThemedText style={[styles.message, { color: colors.textSecondary }]}>
        If you leave now, your changes will be lost.
      </ThemedText>

      <View style={styles.buttonRow}>
        <Button style={styles.button} text="Go Back" onPress={onGoBack} />
        <Button
          style={[styles.button, { backgroundColor: colors.red.background, borderColor: colors.red.border }]}
          textStyle={{ color: colors.red.text }}
          text="Discard Changes"
          onPress={onDiscard}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    width: 400,
    padding: 24,
    borderRadius: 12,
    borderWidth: 1,
    gap: 16,
  },
  title: {
    fontWeight: "600",
    textAlign: "center",
  },
  message: {
    fontSize: 14,
    textAlign: "center",
  },
  buttonRow: {
    flexDirection: "row",
    gap: 12,
    marginTop: 8,
  },
  button: {
    flex: 1,
    height: 44,
  },
});
